export default {
  getCampaigns: state => state.campaigns,
  getCampaignsInsights: state => state.campaignsInsights,
  getAdsetsInsights: state => state.adsetsInsights,
  getAdsInsights: state => state.adsInsights
}
